import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

import { DateUtils } from '../../utils';
import { useLang } from '../../hooks/config';

const Container = styled.div`
    display: inline-block;
    margin-top: 9px;
    color: ${COLORS.mlbGrey4};
    font-family: ${FONTS.primaryFont};
    font-size: 15px;
    font-style: normal;
    font-stretch: normal;
    font-weight: 400;
    letter-spacing: normal;
    line-height: normal;
`;

const DateDuration = ({
    date,
    duration,
}) => {

    const lang = useLang();

    if (!date || !duration) {

        return null;

    }

    const formatedDate = DateUtils.formatDate(date, lang);

    return (
        <Container>
            {`${formatedDate} | ${duration}`}
        </Container>
    );

};

DateDuration.propTypes = {
    date: PropTypes.string,
    duration: PropTypes.string,
};

export default DateDuration;
